import angular from 'angular';
import { MeurhSolicitacoespromocoesService } from './promocoes.service';
import { ListagemService } from '../../../shared/services/listagem.service';

export const MeurhPromocoesListRouting = [
    '$stateProvider',
    function ($stateProvider: angular.ui.IStateProvider) {
        const resolve = {
            'entity': [
                'MeurhSolicitacoespromocoesService',
                'ListagemService',
                '$rootScope',
                '$stateParams',
                '$state',
                '$q',
                function (
                    entityService: MeurhSolicitacoespromocoesService,
                    listagemService: ListagemService,
                    $rootScope: angular.IRootScopeService & {
                        session: any,
                        liberadoTela: (arg: string) => boolean
                    },
                    $stateParams: angular.ui.IStateParamsService,
                    $state: angular.ui.IStateService,
                    $q: angular.IQService
                ) {
                    if (!$stateParams['solicitacao']) {
                        return $q<void>(() => $state.go('promocoes_index'));
                    }

                    return entityService.get($stateParams['solicitacao'])
                        .then((data) => {
                            const visibilidadeLiberada = $rootScope.liberadoTela('LIBERAR_REFATORACAO_VISIBILIDADE');
                            const empresaNoGrupo = listagemService.getEmpresa(data.empresaobj.empresa);
                            const mesmoEstabelecimento = data.estabelecimentoobj.estabelecimento === $rootScope.session.entities.estabelecimento.estabelecimento;

                            const deveRedirecionar = (
                                (visibilidadeLiberada && !empresaNoGrupo) ||
                                (!visibilidadeLiberada && !mesmoEstabelecimento)
                            );

                            if (deveRedirecionar) {
                                return $q(() => $state.go('promocoes_index'));
                            }

                            return data;
                        })
                        .catch((error) => {
                            if (error.status === 404) {
                                return $q(() => $state.go('not_found', $stateParams));
                            }

                            return $q.reject(error);
                        });
                }
            ]
        };

        $stateProvider
            .state('promocoes', {
                url: '/promocoes/{passozeroativo}/?trabalhador?solicitacao&q',
                template: require('html-loader!./wizard/promocoes.wizard.html'),
                controller: 'Meurh\PromocoesWizardController',
                controllerAs: 'mrh_prmcs_wzrd_cntrllr',
                reloadOnSearch: false
            })
            .state('promocoes_index', {
                url: '/promocoes?q',
                template: require('html-loader!./index/promocoes.index.html'),
                controller: 'Meurh\PromocoesListController',
                controllerAs: 'mrh_prmcs_lst_cntrllr',
                reloadOnSearch: false
            })
            .state('promocoes_showbuiltin', {
                parent: 'promocoes_index',
                url: '/showbuiltin/:solicitacao',
                params: {
                    showMode: 'builtin'
                },
                template: require('html-loader!./show/promocoes.showbuiltin.html'),
                resolve,
                controller: 'MeurhPromocoesShowController',
                controllerAs: 'mrh_prmcs_shw_cntrllr',
            })
            .state('promocoes_show', {
                url: '/promocoes/show/:solicitacao?path',
                params: {
                    showMode: 'full'
                },
                template: require('html-loader!./show/promocoes.show.html'),
                resolve,
                controller: 'MeurhPromocoesShowController',
                controllerAs: 'mrh_prmcs_shw_cntrllr',
                reloadOnSearch: false
            });
    }
];
